import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { FeaturesRoutingEnum } from '@features/feature-routing-enum';
import {
  NavigationAction,
  NavigationItem,
  WzbBoNavigationSidebarMenuComponent,
  wzbBoNavigationSidebarMenuIconsDirective,
} from '@wizbii-components/bo-angular-ui';
import { SvgIconComponent } from '@commons/svg-icon/svg-icon.component';

@Component({
  selector: 'adm-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    WzbBoNavigationSidebarMenuComponent,
    RouterLink,
    wzbBoNavigationSidebarMenuIconsDirective,
    SvgIconComponent,
    RouterOutlet,
  ],
})
export class LayoutComponent implements OnInit {
  private readonly router = inject(Router);

  activeRoute: string | string[];
  get icons(): string[] {
    return [...this.items].map((i) => i.icon);
  }

  items = [];
  allItems = [
    {
      id: 'membres',
      route: `/${FeaturesRoutingEnum.Members}`,
      label: 'Membres',
      icon: 'members',
      isImplemented: true,
    },
    {
      id: 'entreprises',
      route: `/${FeaturesRoutingEnum.Firms}`,
      label: 'Entreprises',
      icon: 'firms',
      isImplemented: true,
    },
    {
      id: 'recruteurs',
      route: `/${FeaturesRoutingEnum.Recruteurs}`,
      label: 'Recruteurs',
      icon: 'recruteurs',
      isImplemented: true,
    },
    {
      id: 'offres',
      route: `/${FeaturesRoutingEnum.Offers}`,
      label: "Offres d'emploi",
      icon: 'offers',
      isImplemented: true,
    },
    {
      id: 'emails',
      route: `/${FeaturesRoutingEnum.Emails}`,
      label: 'E-mails',
      icon: 'mails',
      isImplemented: true,
    },
  ];

  ngOnInit(): void {
    this.items = this.allItems.filter((it) => {
      return it.isImplemented || false;
    });

    this.activeRoute = `/${this.router.url.split('/')[1]}`;
  }

  handleItemClicked(item: NavigationItem | NavigationAction): void {
    this.router.navigate([item['route']]);
  }
}
